import Home from "../views/Home.vue";
import UserCreate from "../views/User/Create.vue";
import UserIndex from "../views/User/Index.vue";
//import Login from "../views/Auth/Login.vue";
import StockIndex from "../views/Stock/Index.vue";
import StockCreate from "../views/Stock/Create.vue";
import CustomerIndex from "../views/Customer/Index.vue";
import CustomerCreate from "../views/Customer/Create.vue";
import ItemCreate from "../views/Item/Create.vue";
import UsersCustomersIndex from "../views/UserCustomer/Index.vue";
import UsersCustomersCreate from "../views/UserCustomer/Create.vue";
import UsersExtractionsIndex from "../views/UserExtraction/Index.vue";
import UsersExtractionsCreate from "../views/UserExtraction/Create.vue";
import UsersOperationsIndex from "../views/UserOperation/Index.vue";
import UsersOperationsCreate from "../views/UserOperation/Create.vue";
import OrderCreate from "../views/Order/Create.vue";
import ExtractionsIndex from "../views/Extractions/Index.vue";
import ExtractionsCreate from "../views/Extractions/Create.vue";
import ExtractionView from "../views/Extractions/View.vue";
import Callback from "../views/Auth/Callback.vue";
import Unauthorized from "../views/Auth/Unauthorized.vue";
import { Trans } from "@/plugins/Translation";
import GAApi from "../apiGA/GAApi";

const routes = [
    // {
    //   path: "/login",
    //   name: "login",
    //   component: Login
    // },
    {
        path: "/:lang",
        component: {
            template: "<router-view></router-view>"
        },
        beforeEnter: Trans.routeMiddleware,
        children: [
            {
                path: "",
                name: "home",
                component: Home,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "Users/Index",
                name: "UserIndex",
                component: UserIndex,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "Users/Create/:Id?",
                name: "UserCreate",
                component: UserCreate,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "Stocks/Index",
                name: "StocksIndex",
                component: StockIndex,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "Stocks/Create/:Id?",
                name: "StocksCreate",
                component: StockCreate,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "Customers/Index",
                name: "CustomerIndex",
                component: CustomerIndex,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "Customers/Create/:id?",
                name: "CustomerCreate",
                component: CustomerCreate,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "UsersCustomers/Index",
                name: "UsersCustomersIndex",
                component: UsersCustomersIndex,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "UsersCustomers/Create/:id?",
                name: "UsersCustomersCreate",
                component: UsersCustomersCreate,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "UsersExtractions/Index",
                name: "UsersExtractionsIndex",
                component: UsersExtractionsIndex,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "UsersExtractions/Create/:id?",
                name: "UsersExtractionCreate",
                component: UsersExtractionsCreate,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "UsersOperations/Index",
                name: "UsersOperationsIndex",
                component: UsersOperationsIndex,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "UsersOperations/Create/:id?",
                name: "UsersOperationsCreate",
                component: UsersOperationsCreate,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "Item/Create",
                name: "ItemCreate",
                component: ItemCreate,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "Order/Create",
                name: "OrderCreate",
                component: OrderCreate,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            },
            {
                path: "Extractions/Index",
                name: "ExtractionsIndex",
                component: ExtractionsIndex,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "Extractions/Create",
                name: "ExtractionsCreate",
                component: ExtractionsCreate,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "Extractions/View/:id?",
                name: "ExtractionView",
                component: ExtractionView,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "callback",
                name: "callback",
                component: Callback,
                meta: {
                    requiresAuth: true
                    //role: "base",
                    //function: "Menu Utente"
                }
            }
        ]
    },
    {
        path: "/unauthorized",
        name: "unauthorized",
        beforeEnter(to, from, next) {
            GAApi.GetAccessDeniedPage().then(result => {
                window.location.replace(result.data.Url);
            });
        },
        meta: {
            requiresAuth: false
            //role: "base",
            //function: "Menu Utente"
        }
    },
    {
        // Redirect user to supported lang version.
        path: "*",
        // eslint-disable-next-line
        redirect(to) {
            return Trans.getUserSupportedLang();
        }
    }
];

export default routes;
